import React from 'react';
import Divider from '@material-ui/core/Divider';
import { Tooltip } from '@rcg/ui-react';
import InfoIcon from '@material-ui/icons/Info';
import useStyles from './useStyles';
import Dictionary from '../../utils/dictionary';
import useDictionary from '../../hooks/useDictionary';

const FareTooltip = ({ elementLabel }) => {
  const classes = useStyles();
  const getDictionary = useDictionary(Dictionary);

  const baggageContent = () => {
    return (
      <div className={classes.fareTooltip}>
        <div className={classes.fareTooltipRow}>
          <span className={classes.fareTooltipTitle}>
            {getDictionary(Dictionary.airTypeOfFareTooltipLabel.key)}
          </span>
          <span className={classes.fareTooltipTitle}>
            {getDictionary(Dictionary.airFeesAndRestrictionsTooltipLabel.key)}
          </span>
        </div>
        <Divider classes={{ root: classes.expandedSeparator }} />
        <div className={classes.fareTooltipRow}>
          <span>
            <span className={classes.fareTooltipSubtitle}>
              {getDictionary(Dictionary.airRefundableLabel.key)}
            </span>
            <br />
            {getDictionary(Dictionary.airOutsideCruiseTooltipLabel.key)}
          </span>
          <span>
            {getDictionary(Dictionary.airNoChangeFeesTooltipLabel.key)}
            <br />
            {getDictionary(Dictionary.airNoCancellationFeesTooltipLabel.key)}
          </span>
        </div>
        <Divider classes={{ root: classes.expandedSeparator }} />
        <div className={classes.fareTooltipRow}>
          <span>
            <span className={classes.fareTooltipSubtitle}>
              {getDictionary(Dictionary.airRefundableLabel.key)}
            </span>
            <br />
            {getDictionary(Dictionary.airWithinCruiseTooltipLabel.key)}
          </span>
          <span>
            {getDictionary(Dictionary.airChangeFeeTooltipLabel.key)}
            <br />
            {getDictionary(Dictionary.airCancellationFeeTooltipLabel.key)}
          </span>
        </div>
        <Divider classes={{ root: classes.expandedSeparator }} />
        <div className={classes.fareTooltipRow}>
          <span className={classes.fareTooltipSubtitle}>
            {getDictionary(Dictionary.airNotRefundableLabel.key)}
          </span>
          <span>{getDictionary(Dictionary.airNoRefundTooltipLabel.key)}</span>
        </div>
      </div>
    );
  };
  return (
    <span className={classes.tooltipLabel}>
      <div>{elementLabel}</div>
      <Tooltip
        element={<InfoIcon fontSize="small" />}
        content={baggageContent()}
        toolTipExtraClasses={{ tooltip: classes.fareTooltipContainer }}
        tooltipProps={{
          PopperProps: {
            modifiers: {
              offset: {
                enabled: true,
                offset: `0, 0`,
              },
            },
          },
        }}
      />
    </span>
  );
};

export default FareTooltip;
